import { put, call, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { selectAssetPageQuery } from '../selectors/asset';
import { fetchAssets, deleteAsset, fetchAssetById, bulkDeleteAssets } from '../apis/asset';
import {
  getAssetsAction,
  getAssetsSuccess,
  getAssetsFailure,
  deleteAssetAction,
  getAssetByIdAction,
  deleteAssetSuccess,
  deleteAssetFailure,
  getAssetByIdSuccess,
  getAssetByIdFailure,
  bulkDeleteAssetsAction,
  bulkDeleteAssetsSuccess,
  bulkDeleteAssetsFailure,
} from '../slices/asset';

function* getAssets(action) {
  try {
    // Null page query = the caller wants the full list (the artwork grid has no pager).
    const pageQuery = yield select(selectAssetPageQuery);
    const response = yield call(fetchAssets, { ...(pageQuery || {}), ...action.payload });
    // Tag with the requested type so the reducer can drop stale responses.
    yield put(getAssetsSuccess({ ...response, requestedType: action.payload?.type || null }));
  } catch (error) {
    yield put(
      getAssetsFailure(
        error.response?.data?.error?.message || error.message || 'Failed to fetch assets'
      )
    );
  }
}

function* getAssetById(action) {
  try {
    const response = yield call(fetchAssetById, action.payload);
    yield put(getAssetByIdSuccess(response));
  } catch (error) {
    yield put(
      getAssetByIdFailure(
        error.response?.data?.error?.message || error.message || 'Failed to fetch asset'
      )
    );
  }
}

function* handleDeleteAsset(action) {
  try {
    const { id, assetType } = action.payload;
    yield call(deleteAsset, id);
    yield put(deleteAssetSuccess());
    // Refetch assets after deletion, keeping the app-only scope
    if (assetType) {
      yield put(getAssetsAction({ type: assetType, origin: 'app' }));
    }
  } catch (error) {
    yield put(
      deleteAssetFailure(
        error.response?.data?.error?.message || error.message || 'Failed to delete asset'
      )
    );
  }
}

function* handleBulkDeleteAssets(action) {
  try {
    const { ids, assetType } = action.payload;
    const response = yield call(bulkDeleteAssets, ids);
    // Refetch first: getAssetsAction wipes bulkNotice, success below sets it.
    if (assetType) {
      yield put(getAssetsAction({ type: assetType, origin: 'app' }));
    }
    yield put(bulkDeleteAssetsSuccess(response));
  } catch (error) {
    yield put(
      bulkDeleteAssetsFailure(
        error.response?.data?.error?.message || error.message || 'Failed to delete assets'
      )
    );
  }
}

export default function* assetSaga() {
  yield takeLatest(getAssetsAction.type, getAssets);
  yield takeEvery(getAssetByIdAction.type, getAssetById);
  yield takeEvery(deleteAssetAction.type, handleDeleteAsset);
  yield takeLatest(bulkDeleteAssetsAction.type, handleBulkDeleteAssets);
}
